import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { forkJoin } from 'rxjs';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);

    // Only load critical navigation data - other services load asynchronously in components
    return forkJoin([
        navigationService.get(),
    ]);
};
